import { shallowRef } from "vue";
import { PopupDialogEnum, PopupDialogType } from "@/core/popup-dialog/popup-dialog.model";
import { noop } from "lodash";

interface ConfirmPopupOptions {
    message: string;
    submessage?: string;
    submitBtnText?: string;
    cancelBtnText?: string;
    type: PopupDialogType;
    callback(): void | Promise<void>;
    afterCloseCallback?(): void;
}

const initialData: ConfirmPopupOptions = {
    callback: () => undefined,
    afterCloseCallback: undefined,
    message: "",
    submessage: "",
    submitBtnText: "common.ok",
    cancelBtnText: "dashboard.myAccountComponent.companyInfoTab.teamMembers.verifiedNo",
    type: PopupDialogEnum.info,
};
class ConfirmPopupModel {
    show = shallowRef(false);
    message = shallowRef(initialData.message);
    submessage = shallowRef(initialData.submessage);
    type = shallowRef<PopupDialogType>(initialData.type);
    submitBtnText = shallowRef(initialData.submitBtnText);
    cancelBtnText = shallowRef(initialData.cancelBtnText);
    callback: () => void | Promise<void> = noop;
    afterCloseCallback?: () => void | Promise<void> = initialData.afterCloseCallback;

    resetOptions(): void {
        this.callback = initialData.callback;
        this.cancelBtnText.value = initialData.cancelBtnText;
        this.message.value = initialData.message;
        this.submessage.value = initialData.submessage;
        this.submitBtnText.value = initialData.submitBtnText;
        this.type.value = initialData.type;
    }

    showPopup(options: ConfirmPopupOptions) {
        this.show.value = true;
        this.message.value = options.message;
        this.type.value = options.type;
        if (options.submitBtnText) {
            this.submitBtnText.value = options.submitBtnText;
        } else {
            this.submitBtnText.value =
                this.type.value === "info"
                    ? "common.ok"
                    : "dashboard.myAccountComponent.companyInfoTab.teamMembers.verifiedYes";
        }
        this.cancelBtnText.value =
            options.cancelBtnText ??
            "dashboard.myAccountComponent.companyInfoTab.teamMembers.verifiedNo";
        this.callback = options.callback;
        this.submessage.value = options.submessage;
        this.afterCloseCallback = options.afterCloseCallback;
    }

    closePopup = () => {
        this.show.value = false;
        this.afterCloseCallback?.();
        this.resetOptions();
    };

    confirm = () => {
        const callbackResult = this.callback();

        if (callbackResult instanceof Promise) {
            callbackResult.then(() => {
                this.show.value = false;
            });
        } else {
            this.show.value = false;
        }
    };
}

export const confirmPopupModel = new ConfirmPopupModel();
